export const FILTER_LIST_ATTEMPT = "FILTER_LIST_ATTEMPT";
export const FILTER_LIST_SUCCESS = "FILTER_LIST_SUCCESS";
export const FILTER_LIST_FAILED = "FILTER_LIST_FAILED";
